// gd-featured-shades.js — dynamic-tabs version (per Joel 2026-04-28).
// Tabs are identified by 0-based index strings ("0", "1", …) rendered by
// the section as data-gd-tab="<idx>". Each tab carries its own eyebrow
// string in data-gd-tab-eyebrow-text — JS reads that on switch instead
// of hardcoding "gels"/"powder" / "™".
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.gdFsInit === '1') return;
    root.dataset.gdFsInit = '1';

    const defaultTab = String(root.dataset.defaultTab || '0');
    const tabs = root.querySelectorAll('[data-gd-tab]');
    const panels = root.querySelectorAll('[data-gd-tab-panel]');
    const eyebrow = root.querySelector('[data-gd-tab-eyebrow]');
    const prev = root.querySelector('[data-gd-featured-prev]');
    const next = root.querySelector('[data-gd-featured-next]');

    function activeTrack() {
      const active = root.querySelector('[data-gd-tab-panel][aria-hidden="false"] [data-gd-featured-track]');
      return active;
    }

    function setTab(tab) {
      const tabKey = String(tab);
      tabs.forEach((t) => t.setAttribute('aria-selected', t.dataset.gdTab === tabKey ? 'true' : 'false'));
      panels.forEach((p) => p.setAttribute('aria-hidden', p.dataset.gdTabPanel === tabKey ? 'false' : 'true'));
      if (eyebrow) {
        // Per-tab eyebrow comes from data-gd-tab-eyebrow-text set by Liquid
        // (each tab block carries its own eyebrow setting). Empty string
        // collapses gracefully via the :empty CSS rule on the eyebrow.
        const selectedTabEl = root.querySelector(`[data-gd-tab="${tabKey}"]`);
        eyebrow.textContent = selectedTabEl ? (selectedTabEl.dataset.gdTabEyebrowText || '') : '';
      }
      const track = activeTrack();
      if (track) track.scrollLeft = 0;
      updateArrows();
    }

    function step(direction) {
      const track = activeTrack();
      if (!track) return;
      const first = track.firstElementChild;
      const cardW = first ? first.offsetWidth : 400;
      track.scrollBy({ left: direction === 'prev' ? -(cardW + 16) : cardW + 16, behavior: 'smooth' });
    }

    function updateArrows() {
      const track = activeTrack();
      if (!track) return;
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    }

    tabs.forEach((t) => t.addEventListener('click', () => setTab(t.dataset.gdTab)));
    if (prev) prev.addEventListener('click', () => step('prev'));
    if (next) next.addEventListener('click', () => step('next'));

    panels.forEach((p) => {
      const track = p.querySelector('[data-gd-featured-track]');
      if (track) track.addEventListener('scroll', updateArrows, { passive: true });
    });

    setTab(defaultTab);
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-gd-featured-shades]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
